var keyMirror = require('keymirror');

module.exports = {
    endPoints: {
        GET_USER_DETAILS: 'api/posv3/user/POSLoginDetails',
        GET_LIST_OF_REGISTERS: 'api/posv3/registers/get',
        GET_LIST_OF_ROOMS: 'api/posv3/maintenance/Room_list',
        CHECK_MANAGER_PASSWORD: 'api/v2/discount/CheckManagerApproval',
        CHECK_PIN_NUMBER: 'api/posv3/maintenance/EmployeePinCode',

        GET_LOCATION_SETTINGS: 'api/posv3/maintenance/get_loc_settings',

        VALIDATE_DPH_CREDENTIALS: 'api/dph/v2/check-credentials',
        GET_CUSTOMER_TYPES: 'api/posv3/maintenance/get-customer-types',
        GET_VALIDATED_FROMS: 'api/posv3/maintenance/get_validated_forms',
        GET_ENVIRONMENT_DETAILS: 'api/admin/environment-details',
        GENERATE_LOGIN_TOKEN: 'api/posv3/user/login-token/generate',
        CONSUME_LOGIN_TOKEN: 'api/posv3/user/login-token/consume',
        GET_LD_FLAGS: 'api/admin/ld-flags',
    },

    actions: keyMirror({
        REGISTER_LIST: null,
        SELECT_LOCATION: null,
        REGISTER_SELECTED: null,
        ROOM_SELECTED: null,
        ROOM_ARR_SELECTED: null,
        ROOM_ARR_CLEAR: null,
        ROOMS_LOADED: null,
        TOGGLE_DPH_CREDENTIALS: null,
    }),

    events: keyMirror({
        CHANGE_EVENT: 'changeEvent',
    }),
};



// WEBPACK FOOTER //
// ./ui_src/app/constants/UserConstants.jsx